export default __webpack_public_path__ + "static/media/emoji_events.8d9dd955.svg";